module.exports = __webpack_public_path__ + "img/small_whale18.46fcf1e6.jpg";